var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common__banner__legal"},[_c('img',{attrs:{"src":require("@/assets/images/landing/banner-legal.jpg"),"alt":"","alt":_vm._f("capitalize")(_vm.$t('common.bannerLegal'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }